import React, { createContext, useEffect, useState } from "react";

export const FormContext = createContext();

export const FormProvider = ({ type = "create", data, children }) => {
  const [formData, setFormData] = useState(data);
  const [showModalBarang, setShowModalBarang] = useState(false);
  const [showModalHistory, setShowModalHistory] = useState(false);
  const [validasi, setValidasi] = useState(false);
  const [rowsBarang, setRowsBarang] = useState([]);
  const [rowsSelect, setRowsSelect] = useState([]);

  // const [listPo, setListPo] = [];

  useEffect(() => {
    setFormData(data);
  }, [data]);

  return (
    <FormContext.Provider
      value={{
        formData,
        setFormData,
        showModalBarang,
        setShowModalBarang,
        showModalHistory,
        setShowModalHistory,
        validasi,
        setValidasi,
        rowsBarang,
        setRowsBarang,
        rowsSelect,
        setRowsSelect,
      }}>
      {children}
    </FormContext.Provider>
  );
};
